import { useEffect, useState } from "react";
import "../../assets/scss/login-forms.scss";
import Header from "../../components/header/component";
import Footer from "../../components/footer/component";
import "react-toastify/dist/ReactToastify.css";
import {
  CreateUUID,
  getPortalCD,
  isUserLoggedIn,
  readCookie,
  UserDocMapping,
  PerquisiteBountyEnable,
  checkQueryParams,
  createCookie,
  deleteCookie,
  sendWelcomeEmail,
} from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import dompurify from "dompurify";
import { validateEmail, validatePassword } from "../../validators/genericValidator";
import { ABTESTID_TRANSLATIONOCR_PROCESSIGNG, EMPTY_GUID } from "../../utils/constants";
import i18next from "i18next";
import PathHelper, { getLinkWithLocale, redirectToDashboardWithLocale } from "../../utils/path-helper";
import { getSignUpLink, getForgetPasswordLink } from "../../utils/path-helper";
import {
  APP_NAVIGATION,
  ABTESTID_SUMMARIZER,
  ABTESTID_TRANSLATIONOCR,
  ABTEST_SUMMARIZER_COOKIE,
  ABTEST_TRANSLATIONOCR_COOKIE,
} from "../../utils/constants";

import { getTenantId, currentDomain, getTenantGroupId } from "../../utils/general-config";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import {
  authUser,
  eventServicePost,
  getAddress,
  saveUserAddress,
  signUpAsExternalUser,
  SignupSuccessEvent,
} from "../sign-up/actions";
import { signInUser, getUserDocumentAttributes, validateGuestToken, getUserAbridged } from "./actions";
import { DomainEnum } from "../../services/enum/environment-enum";
import {
  getResumeBuildBaseURL,
  getPdfSimpliBaseURL,
  getSignSimpliBaseURL,
  getWorksimpliEndPoint,
} from "../../services/api-constants";
import ReactLoader from "../../components/resumebuild-loader/component";
import ResumeBuildSignIn from "./rb";
import SignSimpliSignIn from "./ss";
import LegalSimpliSignIn from "./ls";
import PdfSimpliSignIn from "./ps";
import { addWelcomeDocument, ProcessSignInRequest, ProcessSignUpRequest } from "../../utils/document-helper";
import { getABtestData, SwitchVisitorUserAbTest } from "./actions";
import { jwtDecode } from "jwt-decode";
import { updateCookie, ConductABTest, retrieveAbTestConfiguration } from "../../utils/abtest-helper";
import { signInJcUser } from "./actions";
import PSRSignIn from "./PSReSkining/Psr";
import { useNavigate, useParams } from "react-router-dom";

const SignIn = ({ funnelStep }) => {
  // useDataTrack("login");
  let { locale } = useParams();
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const queryParams = new URLSearchParams(window.location.search);
  let signUpLink = getSignUpLink(locale, window.location.search);
  let forgetpwdLink = getForgetPasswordLink(locale);
  const navigate = useNavigate();
  const [emailId, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState();
  const [disableBtn, setdisableBtn] = useState(false);
  const [showLoader, setShowLoader] = useState("d-none");
  const [isProcessing, setIsProcessing] = useState(false);
  let PathRedirectDashboard = PathHelper(APP_NAVIGATION.DASH);
  let pathRedirect = PathHelper(APP_NAVIGATION.SINI);
  let subDomainParam;
  if (queryParams.has("q")) {
    // NOTE :: This query param will let us know from which sub domain, user is getting redirect from.
    subDomainParam = queryParams.get("q");
  }
  const domain = currentDomain()?.toLowerCase() || "";

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          })
          .then((res) => {
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        setLoginError(true);
        setLoginErrorMessage("Failed to login with google");
      }
    },
    onError: (errorResponse) => {
      setLoginError(true);
      setLoginErrorMessage("Failed to login with google");
      console.log(errorResponse);
    },
  });

  const appleLogin = async ({ user, authorization }) => {
    try {
      const { id_token: idToken } = authorization;
      if (!idToken) {
        setLoginError(true);
        // setLoginErrorMessage("Authorization token not found.");
        return;
      }
      const decodedToken = jwtDecode(idToken);
      const email = user?.email || decodedToken?.email;
      const fullName =
        user?.name?.firstName && user?.name?.lastName ? `${user.name.firstName} ${user.name.lastName}` : "";
      const sub = decodedToken?.sub;
      responseApple({ ...decodedToken, fullName }, authorization?.code);
    } catch (error) {
      console.error("Error during Apple login:", error);
      setLoginError(true);
      setLoginErrorMessage(error.message || "Failed to log in with Apple.");
    }
  };

  const IsValidGuest = () => {
    if (queryParams.has("gusr")) {
      let params = {
        InvitationToken: queryParams.get("gusr"),
        ParentGuid: queryParams.get("pgid"),
        TenantGroupId: getTenantGroupId(),
      };

      validateGuestToken(params).then((response) => {
        if (!!response && response.isTokenValid) {
          //TODO:set email in the textbox response.Email
          setEmail(response.email);
          setdisableBtn(true);
        }
      });
    }
  };

  useEffect(() => {
    IsValidGuest();
    if (isUserLoggedIn()) {
      getUserAbridged().then((response) => {
        if (!!response) {
          NavigationHandler(
            readCookie("userguid"),
            PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)
          );
        } else {
          NavigationHandler(readCookie("userguid"), false);
        }
      });
    }
  }, []);
  const backClickHandler = () => {
    navigate(pathRedirect.back);
  };

  const onEmailChangeHandler = (e) => {
    setEmailError(false);
    setPasswordError(false);
    const {
      target: { value },
    } = e;
    setEmail(value);
  };
  const onPwdChangeHandler = (e) => {
    setPasswordError(false);
    const {
      target: { value },
    } = e;
    setPwd(value);
  };
  const onPasswordKeyPress = (e) => {
    const { charCode } = e;
    if (charCode === 13) {
      onSignIn();
    }
  };
  const onSignIn = () => {
    setShowLoader("d-block");
    let uid = CreateUUID();
    setLoginError(false);
    const isValid = validateData();
    if (isValid) {
      const params = {
        username: emailId.trim(),
        password: pwd.trim(),
        tenantGroupId: getTenantGroupId(),
        parentId: queryParams.get("pgid"),
        invitationToken: queryParams.get("gusr"),
      };

      signInUser(params, domain)
        .then(async (signInResponse) => {
          signingResponse(signInResponse);
        })
        .catch((error) => {
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          setPasswordError(true);
          if (error.response?.data?.isAccountLocked) {
            setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
            setPwd("");
            setdisableBtn(false);
          } else {
            setPwd("");
            setPasswordErrorMsg(
              domain === DomainEnum.PDFSIMPLI ||
                domain === DomainEnum.RESUMEBUILD ||
                currentDomain() === DomainEnum.SIGNSIMPLI
                ? t("generic_error.Invalid_login_attempt")
                : t("sign_in.email_error_alert")
            );
          }
          setdisableBtn(false);
        });
    } else {
      setShowLoader("d-none");
      setdisableBtn(false);
    }
  };

  const signingResponse = async (signInResponse) => {
    const isGuestUser = signInResponse?.isGuestUser;
    const isPerquisiteBountyEnable = signInResponse?.isPerquisiteBountyEnable;
    try {
      handlingTransOCRCookieSignIn(
        ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
        signInResponse.validUserGuid,
        ABTEST_TRANSLATIONOCR_COOKIE
      );
      //for old user delete cookie and for new user update cookie
      const response = await getABtestData(ABTESTID_SUMMARIZER, signInResponse.validUserGuid);
      if (!!response) {
        if (response.abTestVariant !== 0) {
          updateCookie(ABTESTID_SUMMARIZER, response.abTestVariant);
        } else {
          deleteCookie(ABTEST_SUMMARIZER_COOKIE);
        }
      }
    } catch (error) {
      console.error("Error in checkAbTest:", error);
    }
    if (!!signInResponse && signInResponse.isAccountLocked) {
      setPasswordError(true);
      setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
      setPwd("");
      setdisableBtn(false);
      setShowLoader("d-none");
    } else {
      if (!!signInResponse && signInResponse.isMigratedUser) {
        setPasswordError(true);
        setPasswordErrorMsg(`${i18next.t("sign_in.migrated_user")}`);
        setPwd("");
        setdisableBtn(false);
        setShowLoader("d-none");
      } else if (!!signInResponse) {
        const { validUserGuid, isMigratedUser } = signInResponse;
        if (validUserGuid == EMPTY_GUID) {
          setPasswordError(true);
          setPasswordErrorMsg(`${i18next.t("sign_in.no_account")}`);
          setPwd("");
          setdisableBtn(false);
          setShowLoader("d-none");
        } else if (isMigratedUser) {
          setPasswordError(true);
          setPasswordErrorMsg(`${i18next.t("sign_in.migrated_user")}`);
          setPwd("");
          setdisableBtn(false);
          setShowLoader("d-none");
        } else {
          let data = {
            Id: CreateUUID(),
            UserId: validUserGuid,
            VisitorId: readCookie("visitorGuid"),
            VisitId: readCookie("visitGuid"),
          };

          eventServicePost(data).then((serviceResponse) => {});

          // queryId needs to be populated from query string if any
          // let queryId = queryParams.has("qid") ? queryParams.get("qid") : "";
          if (checkQueryParams(queryParams)) {
            setIsProcessing(true);
            ProcessSignInRequest(queryParams, validUserGuid, isPerquisiteBountyEnable, false, isGuestUser).then(
              (processResponse) => {
                console.log("Process response and before navigate...", processResponse);
                if (!!processResponse) {
                  console.log("Process response and navigate...");
                  NavigationHandler(validUserGuid, isPerquisiteBountyEnable, isGuestUser);
                } else {
                  console.log("error at process response...");
                  NavigationHandler(validUserGuid, isPerquisiteBountyEnable, isGuestUser);
                }
              }
            );
          } else {
            console.log("Direct login.");
            NavigationHandler(validUserGuid, isPerquisiteBountyEnable, isGuestUser);
          }
          //NavigationHandler(validUserGuid, isPremiumUser);
        }
      }
    }
  };

  const NavigationHandler = (validUserGuid, isPerquisiteBountyEnable = false, isGuestUser) => {
    //
    if (currentDomain() === DomainEnum.RESUMEBUILD) {
      let docid = "";
      let type = "";
      if (queryParams.has("docid")) {
        docid = queryParams.get("docid");
      }
      if (queryParams.has("type")) {
        // doctype comes from resume flow
        type = queryParams.get("type");
      } else if (queryParams.has("doctype")) {
        // doctype comes from WP sign in page, later will be doctype and type will be removed to be in sync.
        type = queryParams.get("doctype");
      }
      if (!!docid) {
        UserDocMapping(docid, validUserGuid).then((mappingResponse) => {
          getUserDocumentAttributes(validUserGuid, 10)
            .then((abridgedResponse) => {
              NavigationHandlerForRB(locale, docid, type, abridgedResponse.docCount);
            })
            .catch((error) => {
              NavigationHandlerForRB(locale, docid, type, 0);
            });
        });
      } else if (!!type) {
        NavigationHandlerForRB(locale, "", type, 0);
      } else {
        getUserDocumentAttributes(validUserGuid, 10)
          .then((abridgedResponse) => {
            if (!!abridgedResponse) {
              NavigationHandlerForRB(locale, 0, "", abridgedResponse.docCount);
            } else {
              NavigationHandlerForRB(locale, docid, type, 0);
            }
          })
          .catch((error) => {
            NavigationHandlerForRB(locale, "", "", 0);
          });
        //NavigationHandlerForRB(locale, docid, type, 0);
      }
    } else if (currentDomain() === DomainEnum.PDFSIMPLI) {
      NavigationHandlerForPDFsimpli(locale, "", "", isGuestUser, 0, isPerquisiteBountyEnable);
    } else if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      NavigationHandlerForSignSimpli(locale, "", "", isGuestUser, 0, isPerquisiteBountyEnable);
    } else if (currentDomain() === DomainEnum.WORKSIMPLI) {
      NavigationHandlerForWorkSimpli(locale, isGuestUser, isPerquisiteBountyEnable);
    }

    // NOTE ::: If local env then redirect on home page else on dashboard.
    else if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
      navigate(PathRedirectDashboard.cstm);
    } else {
      redirectToDashboardWithLocale(locale);
    }
  };
  const NavigationHandlerForRB = (locale, docId, type, numberOfDocs) => {
    let urlPrefix = "";
    let urlPost = "";
    if (currentDomain() === DomainEnum.RESUMEBUILD) {
      urlPrefix = getResumeBuildBaseURL;
      if (!!type && type.toLowerCase() == "cvlt") {
        if (!!docId) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docId;
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letters");
        }
      } else {
        if (!!docId) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review") + "?docid=" + docId;
        } else if (numberOfDocs > 0) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes");
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "introduction");
        }
      }
      console.log("NavigationHandlerForRB ", urlPost);
      window.location.assign(urlPost);
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
        navigate(PathRedirectDashboard.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };

  const NavigationHandlerForPDFsimpli = (locale, docId, type, isGuestUser, numberOfDocs, isPerquisiteBountyEnable) => {
    let urlPrefix = "";
    let urlPost = "";
    if (currentDomain() === DomainEnum.PDFSIMPLI) {
      urlPrefix = getPdfSimpliBaseURL;
      if (!isPerquisiteBountyEnable && isPerquisiteBountyEnable === false && !isGuestUser && !queryParams.has("pgid")) {
        console.log("Non paid user..");
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
        //urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
      } else if (!!type && type.toLowerCase() === "cvlt") {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docId;
      } else {
        if (!!docId) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review") + "?docid=" + docId;
        } else if (numberOfDocs > 0) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes");
        } else {
          //urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "introduction");
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
        }
      }
      console.log("NavigationHandlerForPDFsimpli", urlPost);
      window.location.assign(urlPost);
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` === "DEVELOPMENT") {
        navigate(PathRedirectDashboard.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };

  const NavigationHandlerForSignSimpli = (locale, docId, type, isGuestUser, numberOfDocs, isPerquisiteBountyEnable) => {
    let urlPrefix = "";
    let urlPost = "";
    //
    if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      urlPrefix = getSignSimpliBaseURL;
      if (!isPerquisiteBountyEnable && isPerquisiteBountyEnable === false && !isGuestUser && !queryParams.has("pgid")) {
        console.log("Non paid user..");
        urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
        //urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
      } else if (!!type && type.toLowerCase() === "cvlt") {
        urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docId;
      } else {
        if (!!docId) {
          urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "review") + "?docid=" + docId;
        } else if (numberOfDocs > 0) {
          urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "resumes");
        } else {
          //urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "introduction");
          urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
        }
      }
      console.log("NavigationHandlerForSignSimpli", urlPost);
      window.location.assign(urlPost);
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` === "DEVELOPMENT") {
        navigate(PathRedirectDashboard.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };
  const NavigationHandlerForWorkSimpli = (locale, isGuestUser, isPerquisiteBountyEnable) => {
    let urlPrefix = getWorksimpliEndPoint;
    let urlPost = "";

    if (!isPerquisiteBountyEnable && !isGuestUser && !queryParams.has("pgid")) {
      console.log("Non paid user..");
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
    } else {
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
    }
    window.location.assign(urlPost);
  };

  const validateData = () => {
    setEmailError(false);
    setPasswordError(false);
    let errors = 0;
    let emailValidator = validateEmail(emailId.trim());
    if (emailValidator.isValid === false) {
      ++errors;
      setEmailError(true);
      setPwd("");
      if (domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI || domain === DomainEnum.WORKSIMPLI) {
        setEmailErrorMsg(emailValidator.errorMessage);
        setPasswordErrorMsg(`${i18next.t("sign_in.wrong_email_format_message")}`);
      } else if (domain === DomainEnum.RESUMEBUILD) {
        setEmailErrorMsg(emailValidator.errorMessage);
      } else {
        setEmailErrorMsg(`${i18next.t("generic_error.Invalid_login_attempt")}`);
      }
      return;
    }
    let passwordValidator = validatePassword(pwd);
    if (passwordValidator.isValid === false) {
      ++errors;
      setPasswordError(true);
      if (pwd.length === 0) {
        setPwd("");
        setPasswordErrorMsg(
          domain === DomainEnum.PDFSIMPLI ||
            domain === DomainEnum.RESUMEBUILD ||
            currentDomain() === DomainEnum.SIGNSIMPLI
            ? t("generic_error.Invalid_login_attempt")
            : t("sign_in.password_error_alert")
        );
      } else {
        setPwd("");
        setPasswordErrorMsg(
          domain === DomainEnum.PDFSIMPLI ||
            domain === DomainEnum.RESUMEBUILD ||
            currentDomain() === DomainEnum.SIGNSIMPLI
            ? t("generic_error.Invalid_login_attempt")
            : t("sign_in.password_error_alert")
        );
      }
    }
    if (errors > 0) {
      ++errors;
      setdisableBtn(false);
      return false;
    } else {
      setdisableBtn(true);
      return true;
    }
  };
  const responseGoogle = (response, accessToken) => {
    let fromGoogle = true;
    if (!!response && !!accessToken) {
      setShowLoader("d-block");
      setEmailError(false);

      const { email, id } = response;
      const externalData = {
        createUser: {
          countryCD: readCookie("country"),
          currencyCD: readCookie("currency"),
          portalCD: getPortalCD(locale),
          parentUserGuid: "",
          firstName: "",
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(subDomainParam),
          tenantGroupId: getTenantGroupId(),
          designVersion: "reskin",
        },
        externalLoginInfo: {
          loginType: 2,
          providerKey: id,
        },
      };
      signUpAsExternalUser(externalData)
        .then((response) => {
          if (!!response) {
            const authData = {
              Username: email.trim(),
              UserGuid: response.userGuid,
              Email: email.trim(),
            };

            authUser(authData, subDomainParam).then(async (authResponse) => {
              if (!!authResponse) {
                let data = {
                  Id: CreateUUID(),
                  UserId: response.userGuid,
                  VisitorId: readCookie("visitorGuid"),
                  VisitId: readCookie("visitGuid"),
                };
                eventServicePost(data).then((eventServiceResponse) => {});
                if (response.isSocialUserExists === true) {
                  try {
                    handlingTransOCRCookieSignIn(
                      ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
                      response.userGuid,
                      ABTEST_TRANSLATIONOCR_COOKIE
                    );
                    //for old user delete cookie and for new user update cookie
                    const abResponse = await getABtestData(ABTESTID_SUMMARIZER, response.userGuid);
                    if (!!abResponse) {
                      if (abResponse.abTestVariant !== 0) {
                        updateCookie(ABTESTID_SUMMARIZER, abResponse.abTestVariant);
                      } else {
                        deleteCookie(ABTEST_SUMMARIZER_COOKIE);
                      }
                    }
                  } catch (error) {
                    console.error("Error in checkAbTest:", error);
                  }
                  getAddress(response.userGuid).then((addResponse) => {
                    if (!!addResponse) {
                      var addressReq = {
                        UserGuid: response.userGuid,
                        City: addResponse[0],
                        State: addResponse[1],
                        Country: addResponse[2],
                        ZipCode: addResponse[3],
                        AddressType: 0,
                        IsActive: 1,
                        TenantId: getTenantId(subDomainParam),
                      };
                      saveUserAddress(addressReq).then((addressResponse) => {
                        if (!!addressResponse) {
                          SignupSuccessEvent(response.userGuid, email.trim())
                            .then((eventTrackResponse) => {
                              if (checkQueryParams(queryParams)) {
                                setIsProcessing(true);
                                ProcessSignInRequest(queryParams, response.userGuid, true).then((processResponse) => {
                                  if (!!processResponse) {
                                    console.log("Process response and navigate...");
                                    if (!!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)) {
                                      NavigationHandler(
                                        response.userGuid,
                                        PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)
                                      );
                                    } else {
                                      NavigationHandler(response.userGuid);
                                    }
                                  } else {
                                    console.log("error at process response...");
                                    setShowLoader("d-none");
                                    setdisableBtn(false);
                                    setLoginError(true);
                                    setLoginErrorMessage(t("generic_error.inaction_message"));
                                    NavigationHandler(response.userGuid);
                                  }
                                });
                              } else {
                                // Direct Sign up
                                if (!!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)) {
                                  NavigationHandler(
                                    response.userGuid,
                                    PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)
                                  );
                                } else {
                                  NavigationHandler(response.userGuid);
                                }
                              }
                            })
                            .catch(() => {
                              console.log(" Exception Sign up");
                              NavigationHandler(response.userGuid);
                            });
                        } else {
                          //if response part of saveuseraddress api
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                          // logging
                        }
                      }); //saveuseraddress api
                    } else {
                      //if response part of getaddress api
                      setShowLoader("d-none");
                      setdisableBtn(false);
                      setLoginError(true);
                      setLoginErrorMessage(t("generic_error.inaction_message"));
                    }
                  });
                  //get address api
                } else {
                  ConductABTest(response, externalData.createUser.portalCD);
                  getAddress(response.userGuid).then((addResponse) => {
                    if (!!addResponse) {
                      var addressReq = {
                        UserGuid: response.userGuid,
                        City: addResponse[0],
                        State: addResponse[1],
                        Country: addResponse[2],
                        ZipCode: addResponse[3],
                        AddressType: 0,
                        IsActive: 1,
                        TenantId: getTenantId(subDomainParam),
                      };
                      saveUserAddress(addressReq).then((addressResponse) => {
                        if (!!addressResponse) {
                          SignupSuccessEvent(response.userGuid, email.trim())
                            .then(async (eventTrackResponse) => {
                              if (checkQueryParams(queryParams)) {
                                setIsProcessing(true);
                                ProcessSignInRequest(queryParams, response.userGuid, false, fromGoogle).then(
                                  async (processResponse) => {
                                    if (!!processResponse) {
                                      if (
                                        currentDomain() === DomainEnum.PDFSIMPLI ||
                                        currentDomain() === DomainEnum.WORKSIMPLI ||
                                        currentDomain() === DomainEnum.SIGNSIMPLI
                                      ) {
                                        await sendWelcomeEmail(response.userGuid, locale);
                                      }
                                      console.log("Process response and navigate...");
                                      NavigationHandler(response.userGuid, false);
                                    } else {
                                      console.log("error at process response...");
                                      NavigationHandler(response.userGuid, false);
                                    }
                                  }
                                );
                              } else {
                                if (
                                  currentDomain() === DomainEnum.PDFSIMPLI ||
                                  currentDomain() === DomainEnum.WORKSIMPLI ||
                                  currentDomain() === DomainEnum.SIGNSIMPLI
                                ) {
                                  await sendWelcomeEmail(response.userGuid, locale);
                                  await addWelcomeDocument(response.userGuid);
                                }
                                // Direct Sign up
                                console.log(" Direct Sign up");
                                NavigationHandler(response.userGuid, false);
                              }
                            })
                            .catch(() => {
                              console.log(" Exception Sign up");
                              NavigationHandler(response.userGuid);
                            });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                          // logging
                        }
                      });
                    } else {
                      setShowLoader("d-none");
                      setdisableBtn(false);
                      setLoginError(true);
                      setLoginErrorMessage(t("generic_error.inaction_message"));
                    }
                  });
                  //get address api
                } //else part of isSocialUserExists flag
              } else {
                setShowLoader("d-none");
                setdisableBtn(false);
                setLoginError(true);
                setLoginErrorMessage(t("generic_error.inaction_message"));
              }
            });
          } else {
            setShowLoader("d-none");
            // toggleLoader(false);
            setdisableBtn(false);
            setLoginError(true);
            setLoginErrorMessage(t("sign_up.user_exists"));
          }
        })
        .catch((error) => {
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          if (error.response?.data?.isAccountLocked) {
            setPasswordError(true);
            setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
            setPwd("");
            setdisableBtn(false);
          } else {
            setPwd("");
            setPasswordErrorMsg(
              domain === DomainEnum.PDFSIMPLI ||
                domain === DomainEnum.RESUMEBUILD ||
                currentDomain() === DomainEnum.SIGNSIMPLI
                ? t("generic_error.Invalid_login_attempt")
                : t("sign_in.email_error_alert")
            );
          }
        });

      // signUpExternalUser(externalData)
      //   .then((response) => {
      //     if (!!response) {
      //       let eventData = {
      //         Id: CreateUUID(),
      //         UserId: response.UserGuid,
      //         VisitorId: readCookie("visitorGuid"),
      //         VisitId: readCookie("visitGuid"),
      //       };
      //       eventServicePost(eventData).then((serviceResponse) => {});

      //       NavigationHandler(response.UserGuid);
      //     }
      //   })
      //   .catch((error) => {
      //     setLoginError(true);
      //     setLoginErrorMessage(error.message);
      //   });

      // let emailTest = email;
    }
  };
  const responseFacebook = (response) => {
    let fromFaceBook = true;
    if (!!response && response.status !== "unknown") {
      setShowLoader("d-block");
      setEmailError(false);
      const { name, email, id } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            portalCD: getPortalCD(locale),
            currencyCD: readCookie("currency"),
            parentUserGuid: "",
            firstName: name,
            lastName: "",
            company: "",
            title: "",
            email: email, //email
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 1,
            providerKey: id, // "100732998798818",
          },
        };

        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              authUser(authData, subDomainParam).then(async (authResponse) => {
                if (!!authResponse) {
                  let data = {
                    Id: CreateUUID(),
                    UserId: response.userGuid,
                    VisitorId: readCookie("visitorGuid"),
                    VisitId: readCookie("visitGuid"),
                  };
                  if (response.isSocialUserExists === true) {
                    try {
                      handlingTransOCRCookieSignIn(
                        ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
                        response.userGuid,
                        ABTEST_TRANSLATIONOCR_COOKIE
                      );
                      //for old user delete cookie and for new user update cookie
                      const abResponse = await getABtestData(ABTESTID_SUMMARIZER, response.userGuid);
                      if (!!abResponse) {
                        if (abResponse.abTestVariant !== 0) {
                          updateCookie(ABTESTID_SUMMARIZER, abResponse.abTestVariant);
                        } else {
                          deleteCookie(ABTEST_SUMMARIZER_COOKIE);
                        }
                      }
                    } catch (error) {
                      console.error("Error in checkAbTest:", error);
                    }
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then((eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignInRequest(queryParams, response.userGuid, true).then((processResponse) => {
                                    if (!!processResponse) {
                                      console.log("Process response and navigate...");
                                      if (!!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)) {
                                        NavigationHandler(
                                          response.userGuid,
                                          PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)
                                        );
                                      } else {
                                        NavigationHandler(response.userGuid);
                                      }
                                    } else {
                                      console.log("error at process response...");
                                      setShowLoader("d-none");
                                      setdisableBtn(false);
                                      setLoginError(true);
                                      setLoginErrorMessage(t("generic_error.inaction_message"));
                                      NavigationHandler(response.userGuid);
                                    }
                                  });
                                } else {
                                  // Direct Sign up
                                  if (!!PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)) {
                                    NavigationHandler(
                                      response.userGuid,
                                      PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid)
                                    );
                                  } else {
                                    NavigationHandler(response.userGuid);
                                  }
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            //if response part of saveuseraddress api
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        }); //saveuseraddress api
                      } else {
                        //if response part of getaddress api
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } else {
                    ConductABTest(response, externalData.createUser.portalCD);
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then(async (eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  setIsProcessing(true);
                                  ProcessSignInRequest(queryParams, response.userGuid, false, fromFaceBook).then(
                                    async (processResponse) => {
                                      if (!!processResponse) {
                                        if (
                                          currentDomain() === DomainEnum.PDFSIMPLI ||
                                          currentDomain() === DomainEnum.WORKSIMPLI ||
                                          currentDomain() === DomainEnum.SIGNSIMPLI
                                        ) {
                                          await sendWelcomeEmail(response.userGuid, locale);
                                        }
                                        console.log("Process response and navigate...");
                                        NavigationHandler(response.userGuid, false);
                                      } else {
                                        console.log("error at process response...");
                                        NavigationHandler(response.userGuid, false);
                                      }
                                    }
                                  );
                                } else {
                                  // Direct Sign up
                                  if (
                                    currentDomain() === DomainEnum.PDFSIMPLI ||
                                    currentDomain() === DomainEnum.WORKSIMPLI ||
                                    currentDomain() === DomainEnum.SIGNSIMPLI
                                  ) {
                                    await sendWelcomeEmail(response.userGuid, locale);
                                    await addWelcomeDocument(response.userGuid);
                                  }

                                  console.log(" Direct Sign up");
                                  NavigationHandler(response.userGuid, false);
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        });
                      } else {
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } //else part of isSocialUserExists flag
                } else {
                  setShowLoader("d-none");
                  setdisableBtn(false);
                  setLoginError(true);
                  setLoginErrorMessage(t("generic_error.inaction_message"));
                }
              });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setLoginErrorMessage(t("sign_up.user_exists"));
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI ||
                  domain === DomainEnum.RESUMEBUILD ||
                  currentDomain() === DomainEnum.SIGNSIMPLI
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert")
              );
            }
          });

        // signUpExternalUser(externalData)
        //   .then((response) => {
        //     if (!!response) {
        //       let eventData = {
        //         Id: CreateUUID(),
        //         UserId: response.UserGuid,
        //         VisitorId: readCookie("visitorGuid"),
        //         VisitId: readCookie("visitGuid"),
        //       };
        //       eventServicePost(eventData).then((serviceResonse) => {});

        //       NavigationHandler(response.UserGuid);
        //     }
        //   })
        //   .catch((error) => {
        //     setLoginError(true);
        //     setLoginErrorMessage(error.message);
        //   });
      } else {
        setPasswordError(true);
        setPasswordErrorMsg(`${i18next.t("sign_in.facebook_invalid")}`);
        setPwd("");
        //setdisableBtn(false);
        setShowLoader("d-none");
      }
    }
  };

  const responseApple = (response, code) => {
    if (!!response && !!code) {
      setShowLoader("d-block");
      setEmailError(false);
      const { email, fullName, sub } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            currencyCD: readCookie("currency"),
            portalCD: getPortalCD(locale),
            parentUserGuid: "",
            firstName: fullName,
            lastName: "",
            company: "",
            title: "",
            email: email,
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 4,
            providerKey: sub,
          },
        };
        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
              createCookie("userguid", response.userGuid, 1);
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              authUser(authData, subDomainParam).then((authResponse) => {
                if (!!authResponse) {
                  let data = {
                    Id: CreateUUID(),
                    UserId: response.userGuid,
                    VisitorId: readCookie("visitorGuid"),
                    VisitId: readCookie("visitGuid"),
                  };
                  eventServicePost(data).then((eventServiceResponse) => {});
                  if (response.isSocialUserExists === true) {
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then((eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                    (processResponse) => {
                                      if (!!processResponse) {
                                        console.log("Process response and navigate...");
                                        if (!!isPerquisiteBountyEnable) {
                                          NavigationHandler(
                                            response.userGuid,
                                            isPerquisiteBountyEnable,
                                            response.isSocialUserExists
                                          );
                                        } else {
                                          NavigationHandler(response.userGuid);
                                        }
                                      } else {
                                        console.log("error at process response...");
                                        setShowLoader("d-none");
                                        setdisableBtn(false);
                                        setLoginError(true);
                                        setLoginErrorMessage(t("generic_error.inaction_message"));
                                        NavigationHandler(response.userGuid);
                                      }
                                    }
                                  );
                                } else {
                                  // Direct Sign up
                                  if (!!isPerquisiteBountyEnable) {
                                    NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                  } else {
                                    NavigationHandler(response.userGuid);
                                  }
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            //if response part of saveuseraddress api
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        }); //saveuseraddress api
                      } else {
                        //if response part of getaddress api
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } else {
                    ConductABTest(response, externalData.createUser.portalCD);
                    getAddress(response.userGuid).then((addResponse) => {
                      if (!!addResponse) {
                        var addressReq = {
                          UserGuid: response.userGuid,
                          City: addResponse[0],
                          State: addResponse[1],
                          Country: addResponse[2],
                          ZipCode: addResponse[3],
                          AddressType: 0,
                          IsActive: 1,
                          TenantId: getTenantId(subDomainParam),
                        };
                        saveUserAddress(addressReq).then((addressResponse) => {
                          if (!!addressResponse) {
                            SignupSuccessEvent(response.userGuid, email.trim())
                              .then(async (eventTrackResponse) => {
                                if (checkQueryParams(queryParams)) {
                                  ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                    async (processResponse) => {
                                      if (!!processResponse) {
                                        if (
                                          currentDomain() === DomainEnum.PDFSIMPLI ||
                                          currentDomain() === DomainEnum.WORKSIMPLI ||
                                          currentDomain() === DomainEnum.SIGNSIMPLI
                                        ) {
                                          await sendWelcomeEmail(response.userGuid, locale);
                                        }
                                        console.log("Process response and navigate...");
                                        NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                      } else {
                                        console.log("error at process response...");
                                        NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                      }
                                    }
                                  );
                                } else {
                                  // Direct Sign up
                                  if (
                                    currentDomain() === DomainEnum.PDFSIMPLI ||
                                    currentDomain() === DomainEnum.WORKSIMPLI ||
                                    currentDomain() === DomainEnum.SIGNSIMPLI
                                  ) {
                                    await sendWelcomeEmail(response.userGuid, locale);
                                    await addWelcomeDocument(response.userGuid);
                                  }
                                  console.log(" Direct Sign up");
                                  NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                }
                              })
                              .catch(() => {
                                console.log(" Exception Sign up");
                                NavigationHandler(response.userGuid);
                              });
                          } else {
                            setShowLoader("d-none");
                            setdisableBtn(false);
                            setLoginError(true);
                            setLoginErrorMessage(t("generic_error.inaction_message"));
                            // logging
                          }
                        });
                      } else {
                        setShowLoader("d-none");
                        setdisableBtn(false);
                        setLoginError(true);
                        setLoginErrorMessage(t("generic_error.inaction_message"));
                      }
                    });
                    //get address api
                  } //else part of isSocialUserExists flag
                } else {
                  setShowLoader("d-none");
                  setdisableBtn(false);
                  setLoginError(true);
                  setLoginErrorMessage(t("generic_error.inaction_message"));
                }
              });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setPwd("");
              setLoginErrorMessage(
                domain === DomainEnum.PDFSIMPLI || currentDomain() === DomainEnum.SIGNSIMPLI
                  ? t("sign_up.email_already_taken")
                  : t("sign_up.user_exists")
              );
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI ||
                  domain === DomainEnum.RESUMEBUILD ||
                  currentDomain() === DomainEnum.SIGNSIMPLI
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert")
              );
            }
          });
      } else {
        setShowLoader("d-none");
        setLoginErrorMessage(t("sign_up.apple_invalid"));
        setLoginError(true);
      }
    }
  };

  const pwdNavigate = () => {
    navigate(forgetpwdLink);
  };
  const signUpNavigate = () => {
    navigate(signUpLink);
  };

  const handlingTransOCRCookieSignIn = async (abTestId, userID, abTestCookie) => {
    let retrieveABtest = retrieveAbTestConfiguration(abTestId, abTestCookie);
    if (retrieveABtest.abTestId != null) {
      const response = await getABtestData(abTestId, userID);
      if (!!response && response.abTestVariant != null && response.abTestVariant !== 0) {
        updateCookie(abTestId, response.abTestVariant);
      } else {
        let switchData = {
          AbTestId: retrieveABtest.abTestId,
          UserId: userID,
          VisitorId: readCookie("visitorGuid"),
          portalCD: getPortalCD(locale),
        };
        SwitchVisitorUserAbTest(switchData).then((response) => {});
      }
    }
  };

  let privacyLinksOption = PathHelper(APP_NAVIGATION.PRVY, false);
  let termsAndConditionOption = PathHelper(APP_NAVIGATION.TUSE, false);

  const AuthenticateJCPartnerUser = async (returnedCodeFromJC, clientID) => {
    try {
      if (locale === undefined) {
        locale = localStorage.getItem("i18nextLng") === "en" ? "" : localStorage.getItem("i18nextLng");
      }
      let portalCD = "SS";
      var jcRequestObject = {
        code: returnedCodeFromJC,
        tenantId: getTenantId(),
        tenantGroupId: getTenantGroupId(),
        portalCD: window.location.hostname.includes("staging") ? "staging-" + portalCD : portalCD,
        countryCD: readCookie("country"),
        locale: "en",
        clientId: clientID,
        IDP: "JUMPCLOUD",
      };

      const domain = DomainEnum.SIGNSIMPLI;

      signInJcUser(jcRequestObject, domain)
        .then(async (signInResponse) => {
          signingResponse(signInResponse);
        })
        .catch((error) => {
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          setPasswordError(true);
          if (error.response?.data?.isAccountLocked) {
            setPasswordErrorMsg(`${i18next.t("sign_in.account_lock")}`);
            setPwd("");
            setdisableBtn(false);
          } else {
            setPwd("");
            setPasswordErrorMsg(
              domain === DomainEnum.PDFSIMPLI ||
                domain === DomainEnum.RESUMEBUILD ||
                currentDomain() === DomainEnum.SIGNSIMPLI
                ? t("generic_error.Invalid_login_attempt")
                : t("sign_in.email_error_alert")
            );
          }
          setdisableBtn(false);
        });

      console.log("AuthenticateJCPartnerUser called with code:", returnedCodeFromJC);
    } catch (error) {
      console.error("AuthenticateUser failed:", error);
      return null;
    }
  };
  return (
    <>
      <Header className="mt-4" />
      <ReactLoader showloader={showLoader} isProcessing={isProcessing} />
      {(() => {
        const domain = currentDomain()?.toLowerCase() || "";
        switch (domain) {
          case DomainEnum.PDFSIMPLI:
            return (
              <PSRSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                appleLogin={appleLogin}
              />
            );
          case DomainEnum.WORKSIMPLI:
            return (
              <PSRSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                appleLogin={appleLogin}
              />
            );
          case DomainEnum.LEGALSIMPLI:
            return (
              <LegalSimpliSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
              />
            );
          case DomainEnum.SIGNSIMPLI:
            return (
              <SignSimpliSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                setLoginError={setLoginError}
                setShowLoader={setShowLoader}
                setLoginErrorMessage={setLoginErrorMessage}
                AuthenticateJCPartnerUser={AuthenticateJCPartnerUser}
                appleLogin={appleLogin}
              />
            );
          default:
          case DomainEnum.RESUMEBUILD:
            return (
              <ResumeBuildSignIn
                pwdNavigate={pwdNavigate}
                signUpNavigate={signUpNavigate}
                onSignIn={onSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                passwordError={passwordError}
                emailError={emailError}
                passwordErrorMsg={passwordErrorMsg}
                onEmailChangeHandler={onEmailChangeHandler}
                emailId={emailId}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                pwd={pwd}
                emailErrorMsg={emailErrorMsg}
              />
            );
        }
      })()}

      {domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.WORKSIMPLI || domain === DomainEnum.SIGNSIMPLI ? (
        ""
      ) : (
        <Footer />
      )}
    </>
  );
};

export default SignIn;
